import '@/ui/styles/main.css'

import { createPinia } from 'pinia'
import { createApp } from 'vue'

import { registerSW } from 'virtual:pwa-register'

import App from '@/app/App.vue'
import { listenForInstall, requestPersistentStorage } from '@/app/install'
import { router } from '@/app/router'
import { vReveal } from '@/ui'

// iOS Safari n'applique `:active` (retour tactile des boutons) qu'en présence d'un écouteur
// tactile. Écouteur passif, déclaré ici : la CSP interdit les gestionnaires inline.
document.addEventListener('touchstart', () => undefined, { passive: true })

listenForInstall()
void requestPersistentStorage()

createApp(App).use(createPinia()).use(router).directive('reveal', vReveal).mount('#app')

// Application installable et ouverture instantanée. Une nouvelle version s'installe en
// arrière-plan et prend effet au prochain lancement : jamais d'interruption pendant une saisie.
if (import.meta.env.PROD) registerSW({ immediate: true })
